module.exports = __webpack_public_path__ + "static/media/biozyme1.73fc8a77.pdf";